import PopupBusinessConcierge from '../businessConciergeService/PopupBusinessConcierge'
import Footer from './Footer'
import classes from './index.module.scss'
import './lang/i18n'
import { PreviewLeft } from './previewLeft'
import { PreviewRight } from './previewRight'

export const InternationalSearchPreview = () => {
  return (
    <div className="p3 flexColumn h100">
      <div className={classes.internationalSearchPreview}>
        <PreviewLeft />
        <PreviewRight />
      </div>
      <div className={classes.divider} style={{ borderTopColor: '#e5e5e8' }} />
      <Footer />
      <PopupBusinessConcierge />
    </div>
  )
}
